module.exports = __webpack_public_path__ + "img/mp.8a731cbc.svg";